import React, { Component } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar'
import DepartmentTable from './DepartmentTable';
import departmentsList from '../../services/departmentsService'
import Loader from "react-loader-spinner";
class DepartmentList extends Component {
    state = { 
        newDepartments: false,
        successful: false,
        failed:false,
        departments:[],
        newDepartment:{
            title:"",
            description:""
        },
        user:{},
        isLoading:true,
        isInitiallyLoaded:true
        
    }
   async componentDidMount() {
        let loggedInUser = localStorage.getItem('currentUser')
        loggedInUser = JSON.parse(loggedInUser)
        let response = await departmentsList.fetchAllDepartments()
        let AllDepartments = await response.data
        this.setState({departments:AllDepartments})
        this.setState({user:loggedInUser})
        this.setState({isLoading:false})
        this.setState({isInitiallyLoaded:false})
    } 
    handleChangeTitle = e =>{
        const newDepartment = {...this.state.newDepartment}
        newDepartment.title = e.currentTarget.value
        this.setState({newDepartment})
    } 
    handleChangeDescription = e =>{
        const newDepartment = {...this.state.newDepartment}
        newDepartment.description = e.currentTarget.value
        this.setState({newDepartment})
    } 
    closeAdd = () => {
        this.setState({newDepartments : false})
    }
    openAdd = () => {
        this.setState({newDepartments: true})
    }
    closeSuccessful = () =>{
        this.setState({successful: false})
    }
    render() { 
        let { user ,departments ,isLoading,successful,isInitiallyLoaded,newDepartment } = this.state
        return ( 
            isInitiallyLoaded ? 
            <div className="flex justify-center items-center h-screen">
                	<Loader type="Oval" className="align-middle" color="#F35D2D" height={100} width={100}/>
            </div> :
            <div className="flex flex-row w-screen">
            <div className=" p-4 bg-white  md:min-h-screen overflow-auto w-60 fixed">
                <Sidebar user={user}/>
                </div>
                <div className="py-8 px-8 ml-72">
                <div className="h-full bg-white rounded-md py-4">
                    <div className=" flex justify-between p-8">
                        {
                            user.is_admin ?
                            <span className="font-bold text-base">
                                    List of all departments
                            </span>
                            :
                            <span className="font-bold text-base">
                                My departments
                            </span>
                        }
                    </div>
                    <div class="px-8">
                       {!isLoading &&  <DepartmentTable fetchedDepartments = {departments}/>}                            
                        {isLoading && 
                         <div className = "px-auto flex justify-center items-center">
                           <p className = "font-bold text-center text-red-500">Fetching Departments...</p>
                                    <Loader
                                    type="Puff"
                                    color="#F35D2D"
                                    height={50}
                                    className="ml-4"
                                    width={50} />
                         </div>
                        }
                    </div>
                    {
                        this.state.newDepartments && (
                            <div className=" w-screen fixed top-0 left-0 h-screen  z-10">
                            <div className="flex flex-col my-4 border-black py-4 px-10 bg-white absolute z-50 bottom-8 left-96 right-96 border-2">
                                <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                    <p className="font-bold text-left">Add New Department</p>
                                    <form  onSubmit= {this.registerDepartment}>
                                        <div className="flex flex-row w-full gap-8 my-4">
                                            <div className="w-full flex flex-col">
                                                <label>
                                                    Department Title
                                                </label>
                                                <input type="text" onChange={this.handleChangeTitle} value={newDepartment.title} className=" text-xs p-3 border-2 border-wvrPrimary rounded-md "/>
                                            </div>
                                        </div>
                                        <div className="flex flex-col my-4">
                                            <label>Department Description</label>
                                            <textarea onChange={this.handleChangeDescription} value={newDepartment.description} cols="30" rows="6" className=" p-3 border-2 border-wvrPrimary rounded-md "></textarea>
                                        </div>
                                        <div className="flex flex-row gap-4 my-4">
                                            <button className="bg-wvrblue text-white py-2 px-8 rounded-md">Register</button>
                                            <button className="bg-wvrPrimary py-2 px-8 rounded-md" onClick={() => this.closeAdd ()}>cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            </div>
                            
                        )
                    }
                    {
                         successful && (
                             <div className="fixed top-8 right-0 bg-wvrLightGreen w-64 text-xs z-20 border-2 border-wvrGreen rounded-md">
                                <div className="flex flex-row py-2 px-4 gap-4">
                                    <div className=" bg-wvrGreen p-1 rounded-md">
                                        <div className="bg-white rounded-full p-1">
                                            <p className="text-wvrGreen"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg></p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <p>Successful you have registered a new User</p>
                                    </div>
                                    <button className=" flex items-center" onClick={() => this.closeSuccessful ()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    </button>
                                </div>
                             </div>
                         )
                     }
                </div>
            </div>
            
        </div>
         );
    }
}
 
export default DepartmentList;